import { createListStore } from "./list";
import { TicketTemplatesService } from "@/services/ticketTemplates";

export const useTicketTemplatesStore = createListStore(
  "ticketTemplates",
  TicketTemplatesService
);
